import { render } from "./index.vue?vue&type=template&id=3f8bab3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3f8bab3c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8bab3c"]])

export default __exports__